/** Devuelve hasta 2 iniciales en mayúscula a partir de un nombre completo. */
export function getInitials(name = '') {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}

/** Formatea una fecha corta, ej. "01 jul 2026". */
export function formatDate(value, options) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(
    'es',
    options ?? { day: '2-digit', month: 'short', year: 'numeric' }
  );
}

/** Formatea fecha + hora, ej. "01 jul, 02:23 p. m.". */
export function formatDateTime(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('es', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Tiempo relativo tipo "hace 5 min". Cae a `formatDate` si es hace más de una semana. */
export function timeAgo(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  const diffMs = Date.now() - date.getTime();
  const diffMin = Math.round(diffMs / 60000);

  if (diffMin < 1) return 'justo ahora';
  if (diffMin < 60) return `hace ${diffMin} min`;

  const diffHrs = Math.round(diffMin / 60);
  if (diffHrs < 24) return `hace ${diffHrs} h`;

  const diffDays = Math.round(diffHrs / 24);
  if (diffDays < 7) return `hace ${diffDays} d`;

  return formatDate(value);
}
